module.exports = __webpack_public_path__ + "img/product2.6a94698f.png";